import PageViewLayout from '@/components/layouts/PageViewLayout/PageViewLayout';
import TopTabBar from '@/components/modules/navigation/TopTabBar/TopTabBar';
import AppointmentsTab from '@/components/modules/pages/bokningar/AppointmentsTab';
import SEO, { seoPropsFromBaseString } from '@/components/modules/SEO';
import EmptyState from '@/components/templates/EmptyState';
import { APP_ROUTES } from '@/constants/pages';
import { isLanding, isServer } from '@/helpers';
import { useAppSelector } from '@/hooks';
import { LoginContext } from '@/hooks/useLogin';
import { _s, _t } from '@/locale';
import { LoginSignupFlowInitiatedFrom } from '@/types/analytics';
import { Fragment, useContext, useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

const bookingsMenu = [
  {
    label: _s('upcomingShort'),
    to: '/bokningar',
  },
  {
    label: _s('pastShort'),
    to: '/bokningar/tidigare',
  },
];

const Appointments = () => {
  const { user } = useAppSelector((state) => state.users);
  const location = useLocation();
  const loginContext = useContext(LoginContext);

  useEffect(() => {
    if (isServer) return;
    window.scrollTo(0, 0);
  }, []);

  const isLogged = Boolean(user && user.token);

  if (!isLogged) {
    let initiatedFrom: LoginSignupFlowInitiatedFrom = 'direct_links';

    if (location.state?.fromNavigation) {
      initiatedFrom = 'navigation_bar_bookings';
    }

    if (location.state?.fromFooter) {
      initiatedFrom = 'footer_bookings';
    }

    return (
      <Fragment key="no-user">
        <PageViewLayout type="mainView" wrapperClass="bg-gradient" footerDisplayOption={{ from: 'md', to: 'all' }}>
          <EmptyState
            title={_s('appointments.emptyState.title')}
            body={_s('appointments.emptyState.body')}
            icon={<img width={354} height={237} src="/images/illustrations/bookings2.png" alt="" />}
            cta={loginContext.renderLoginButton({
              label: _t('appointments.emptyState.button'),
              size: 'sm',
              trackPromptEvent: true,
              initiatedFrom,
            })}
          />
          <SEO {...seoPropsFromBaseString('appointments', '/bokningar')} image={'/images/home-background.jpeg'} />
        </PageViewLayout>
      </Fragment>
    );
  }

  const headerSlot = (
    <div className="mx-auto max-w-md">
      <TopTabBar
        items={bookingsMenu}
        defaultSelected={bookingsMenu.findIndex((item) => item.to === location.pathname)}
      />
    </div>
  );

  return (
    <Fragment key="user">
      <PageViewLayout
        type="mainView"
        headerSlot={headerSlot}
        bottomSlot={headerSlot}
        footerDisplayOption={{ from: 'md', to: 'all' }}
        wrapperClass="bg-gradient"
        {...(isLanding() && { source: 'landing' })}>
        <div className="pt-lg container max-w-screen-md">
          <Switch>
            <Route
              exact
              path={APP_ROUTES.MY_BOOKINGS}
              children={<AppointmentsTab key="upcoming" filter="uFilterActive" />}
            />
            <Route
              path={APP_ROUTES.MY_BOOKINGS_FINISHED}
              children={<AppointmentsTab key="past" past filter="uFilterCanceled" />}
            />
          </Switch>
        </div>
        <SEO {...seoPropsFromBaseString('appointments', '/bokningar')} image={'/images/home-background.jpeg'} />
      </PageViewLayout>
    </Fragment>
  );
};

export default Appointments;
